import { Col, Row } from "react-bootstrap";
import { displayDateAndTime } from "../../../../helper-functions";
import { useTIFFormData } from "../../../../hooks";
import { TissueInformationFormProps } from ".";

export function TIFInitialGradingWithProcedure({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { tissue, initialEval, initialEvalSummary, latestInitialGradingSlitLamp } = useTIFFormData({
        tissueId,
    });

    return (
        <Row>
            <Col>
                <div style={{ fontWeight: "bold" }}>PRE-PROCESSING:</div>
                <div>Tissue # {tissue?.number} </div>
                <div>{initialEvalSummary}</div>
                <div>Slit Lamp D/T: {displayDateAndTime(latestInitialGradingSlitLamp?.createdOn)}</div>
                <div>Slit Lamp Tech: {latestInitialGradingSlitLamp?.createdByUserName}</div>
                <div>Cell Count : {initialEval?.data.cellDensity} cell/mm</div>
                <div>
                    By: {initialEval?.signedByName}, {displayDateAndTime(initialEval?.signedOn)}{" "}
                </div>
            </Col>
        </Row>
    );
}
